import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  icon:string,
  textIcon:string,
  title:string,
  text:string,
  textExtra:string,
  textLink:string,
  linkAdress:string,
  linkOutAdress:string,
  btnOneIcon:string,
  textBtnOne:string,
}

@Component({
  selector: 'app-model-modal-link-one-button',
  templateUrl: './model-modal-link-one-button.component.html',
  styleUrls: ['./model-modal-link-one-button.component.scss']
})
export class ModelModalLinkOneButtonComponent implements OnInit {

  isSafari: any;

  constructor(public dialogRef: MatDialogRef<ModelModalLinkOneButtonComponent>,  @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {

    this.isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
                   navigator.userAgent &&
                   navigator.userAgent.indexOf('CriOS') == -1 &&
                   navigator.userAgent.indexOf('FxiOS') == -1;

  }

}
